import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Tab } from './Tab';
import css from './Tabs.sass';

function Tabs(props) {
  var children = props.children,
      className = props.className,
      classNameInner = props.classNameInner,
      classNameContent = props.classNameContent,
      backgoundColor = props.backgoundColor,
      theme = props.theme;
  var classNames = cx(css.root, theme && css[theme], className);
  return React.createElement("div", {
    className: classNames,
    style: {
      color: backgoundColor
    }
  }, React.createElement("div", {
    className: cx(css.inner, classNameInner)
  }, React.createElement("div", {
    className: cx(css.content, classNameContent)
  }, children)));
}

Tabs.displayName = 'Tabs';
Tabs.propTypes = {
  /**
   * Primary content.
   */
  children: PropTypes.node,
  className: PropTypes.string,
  classNameInner: PropTypes.string,
  classNameContent: PropTypes.string,

  /** background color to use for side shaders */
  backgoundColor: PropTypes.string,
  theme:
  /*#__PURE__*/
  PropTypes.oneOf(['nav', 'crispyCompact', 'noBorder'])
};
Tabs.defaultProps = {};
Tabs.Tab = Tab;
export { Tabs };